import React from 'react';
import { skyflowContext, useSkyflow } from './hook';
const SkyflowElements = ({ children, config }) => {
    useSkyflow();
    return React.createElement(skyflowContext.Provider, { value: config }, children);
};
export default React.memo(SkyflowElements);
//# sourceMappingURL=index.js.map